import { Box, Flex, Image, Text } from "@chakra-ui/react";

import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

function BlogCard({ title, description, date, featuredImage, postUrl, day, month }) {
    const redirectPage = (link) => {
        window.open(link, "_blank");
    };

    return (
        <Flex
            direction="column"
            w="100%"
            h="100%"
            cursor="pointer"
            role="article"
            aria-label={`Publicación: ${title}`}
            transition="all 0.2s ease-in-out"
            _hover={{
                transform: "translateY(-4px)",
                boxShadow: "lg",
                borderRadius: "10px",
            }}
            _active={{
                transform: "translateY(-2px)",
            }}
            _focus={{
                outline: "2px solid",
                outlineColor: "blue.500",
                outlineOffset: "2px",
            }}
        >
            <Flex direction="column" width="full" h="100%" align="end">
                <Box
                    display="flex"
                    w={{ base: "300px", sm: "364px" }}
                    h="256px"
                    as="div"
                    mt={0}
                    borderTopRadius="10px"
                    borderBottomRadius="10px"
                    bgImage={wrapBgImage(featuredImage)}
                    bgPosition="top"
                    bgSize="cover"
                    bgRepeat="no-repeat"
                    boxShadow="4px, 4px, 19px rgba(0, 0, 0, 0.25)"
                    overflowY="visible"
                    onClick={() => redirectPage(postUrl)}
                    position="relative"
                >
                    <Image
                        src={featuredImage}
                        alt={`Imagen destacada: ${title}`}
                        style={{
                            position: "absolute",
                            width: "1px",
                            height: "1px",
                            opacity: 0,
                        }}
                    />
                    <Box
                        position="relative"
                        top="80%"
                        left="75%"
                        backgroundColor="white"
                        height="81px"
                        width="68px"
                        zIndex={1001}
                        borderRadius="lg"
                        aria-label={`Fecha de publicación: ${day} de ${month}`}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            height="100%"
                        >
                            <Text
                                color="#002B49"
                                fontWeight={400}
                                fontSize="2xs"
                                textAlign="center"
                            >
                                {month}
                            </Text>
                            <Text color="#002B49" fontWeight={600} fontSize="xl" textAlign="center">
                                {day}
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Flex>
            <Flex direction="column" w="full">
                <Box
                    mt={10}
                    direction="column"
                    px="10px"
                    textAlign="left"
                    paddingTop="3"
                    paddingBottom="0"
                    height="150px"
                    zIndex={1000}
                    onClick={() => redirectPage(postUrl)}
                >
                    <Text
                        as="h3"
                        textTransform="capitalize"
                        color="black"
                        lineClamp="2"
                        textAlign="start"
                        fontWeight="600"
                        fontSize={{ base: "sm", sm: "md", md: "lg" }}
                    >
                        {title?.toLowerCase()}
                    </Text>
                    <Text
                        fontSize={{ base: "xs", sm: "sm", md: "md" }}
                        color="black"
                        fontWeight={400}
                        textTransform="capitalize"
                        lineClamp={2}
                        textAlign="start"
                    >
                        {description}
                    </Text>
                </Box>
                <Box></Box>
            </Flex>
        </Flex>
    );
}

export default BlogCard;
